import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-churn-flow-reason-template',
  templateUrl: './churn-flow-reason-template.component.html',
  styleUrls: ['./churn-flow-reason-template.component.less'],
  imports: [TranslatePipe, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChurnFlowReasonTemplateComponent {
  public heading = input.required<string>();
  public subheading = input.required<string>();

  public stayWithTellent = output<void>();
  public stillWantToCancel = output<void>();
}
